import { styled } from '@mui/material'
import { Typography } from 'ComponentLibrary'
import { TypographyProps } from 'ComponentLibrary/src/atoms/typography/Typography'

export type DecoratedValueProps = { startDecorator?: string; endDecorator?: string } & TypographyProps

export function DecoratedValue({ children, startDecorator, endDecorator, ...typographyProps }: DecoratedValueProps) {
    return (
        <DecoratedTypography $startDecorator={startDecorator} $endDecorator={endDecorator} {...typographyProps}>
            {children}
        </DecoratedTypography>
    )
}

const DecoratedTypography = styled(Typography, {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})<{ $startDecorator?: string; $endDecorator?: string }>(({ $startDecorator, $endDecorator }) => {
    const startDecoratorValues = $startDecorator
        ? {
              '&:before': {
                  position: 'absolute',
                  content: `"${$startDecorator}"`,
                  left: '-12px',
              },
          }
        : {}
    const endDecoratorValues = $endDecorator
        ? {
              '&:after': {
                  position: 'absolute',
                  content: `"${$endDecorator}"`,
                  right: '-12px',
              },
          }
        : {}
    return {
        width: 'fit-content',
        display: 'inline',
        position: 'relative',
        ...startDecoratorValues,
        ...endDecoratorValues,
    }
})

export default DecoratedValue
